/* eslint-disable import/no-anonymous-default-export */
import * as actionType from "./constants";

const initialState = {
    getMobileRecommendationTemplatesResponse: { isLoading: false },
    projectEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: {},
            last_synced_at: false
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null
    },
    templateEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null
    },
    getMobileRecommendationDefaultTemplateResponse: null,
    getMobileRecommendationTemplateByIdResponse: null,
    getTemplateDropdownListResponse: null,
    getTemplateDropdownListResponseLoading: false,
    addMobileRecommendationTemplateResponse: null,
    addMobileRecommendationTemplateResponseLoading: false,
    editMobileRecommendationTemplateResponse: null,
    editMobileRecommendationTemplateResponseLoading: false,
    deleteMobileRecommendationTemplateResponse: null,
    deleteMobileRecommendationTemplateResponseLoading: false,
    addFCAProjectMobileRecomResponse: null,
    addFCAProjectMobileRecomResponseLoading: false,
    editFcaProjectMobileRecomResponse: null,
    editFCAProjectMobileRecomResponseLoading: false,
    deleteFCAProjectMobileRecomResponse: null,
    deleteFCAProjectMobileRecomResponseLoading: false,
    getFcaProjectMobileRecomResponse: { isLoading: false },
    getFcaProjectMobileRecomByIdResponse: null,
    getSurveyTemplateExportLoading: false,
    getListForCommonFilterResponse: {},
    getGroupUpdateRespose: {},
    fcaSurveyProjectMasterFilterList: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_RECOMMENDATIONS_TEMPLATES_REQUEST:
            return {
                ...state,
                getMobileRecommendationTemplatesResponse: { isLoading: true }
            };
        case actionType.GET_RECOMMENDATIONS_TEMPLATES_SUCCESS:
            return {
                ...state,
                getMobileRecommendationTemplatesResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_RECOMMENDATIONS_TEMPLATES_FAILURE:
            return {
                ...state,
                getMobileRecommendationTemplatesResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.GET_DEFAULT_RECOMMENDATION_TEMPLATE_REQUEST:
            return {
                ...state,
                getMobileRecommendationDefaultTemplateResponse: { isLoading: true }
            };
        case actionType.GET_DEFAULT_RECOMMENDATION_TEMPLATE_SUCCESS:
            return {
                ...state,
                getMobileRecommendationDefaultTemplateResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_DEFAULT_RECOMMENDATION_TEMPLATE_FAILURE:
            return {
                ...state,
                getMobileRecommendationDefaultTemplateResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.GET_RECOMMENDATION_TEMPLATE_BY_ID_REQUEST:
            return {
                ...state,
                getMobileRecommendationTemplateByIdResponse: { isLoading: true }
            };
        case actionType.GET_RECOMMENDATION_TEMPLATE_BY_ID_SUCCESS:
            return {
                ...state,
                getMobileRecommendationTemplateByIdResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_RECOMMENDATION_TEMPLATE_BY_ID_FAILURE:
            return {
                ...state,
                getMobileRecommendationTemplateByIdResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.ADD_RECOMMENDATION_TEMPLATE_DATA_REQUEST:
            return {
                ...state,
                addMobileRecommendationTemplateResponse: null,
                addMobileRecommendationTemplateResponseLoading: true
            };
        case actionType.ADD_RECOMMENDATION_TEMPLATE_DATA_SUCCESS:
            return {
                ...state,
                addMobileRecommendationTemplateResponse: { success: true, ...action.response },
                addMobileRecommendationTemplateResponseLoading: false
            };
        case actionType.ADD_RECOMMENDATION_TEMPLATE_DATA_FAILURE:
            return {
                ...state,
                addMobileRecommendationTemplateResponse: { success: false, ...action.error },
                addMobileRecommendationTemplateResponseLoading: false
            };

        case actionType.UPDATE_RECOMMENDATION_TEMPLATE_DATA_REQUEST:
            return {
                ...state,
                editMobileRecommendationTemplateResponse: null,
                editMobileRecommendationTemplateResponseLoading: true
            };
        case actionType.UPDATE_RECOMMENDATION_TEMPLATE_DATA_SUCCESS:
            return {
                ...state,
                editMobileRecommendationTemplateResponse: { success: true, ...action.response },
                editMobileRecommendationTemplateResponseLoading: false
            };
        case actionType.UPDATE_RECOMMENDATION_TEMPLATE_DATA_FAILURE:
            return {
                ...state,
                editMobileRecommendationTemplateResponse: { success: false, ...action.error },
                editMobileRecommendationTemplateResponseLoading: false
            };

        case actionType.DELETE_SURVEY_TEMPLATE_REQUEST:
            return {
                ...state,
                deleteMobileRecommendationTemplateResponse: null,
                deleteMobileRecommendationTemplateResponseLoading: true
            };
        case actionType.DELETE_SURVEY_TEMPLATE_SUCCESS:
            return {
                ...state,
                deleteMobileRecommendationTemplateResponse: { success: true, ...action.response },
                deleteMobileRecommendationTemplateResponseLoading: false
            };
        case actionType.DELETE_SURVEY_TEMPLATE_FAILURE:
            return {
                ...state,
                deleteMobileRecommendationTemplateResponse: { success: false, ...action.error },
                deleteMobileRecommendationTemplateResponseLoading: false
            };

        case actionType.GET_PROJECTS_LIST_REQUEST:
            return {
                ...state,
                getProjectListResponse: null,
                getProjectListResponseLoading: true
            };
        case actionType.GET_PROJECTS_LIST_SUCCESS:
            return {
                ...state,
                getProjectListResponse: { success: true, ...action.response },
                getProjectListResponseLoading: false
            };
        case actionType.GET_PROJECTS_LIST_FAILURE:
            return {
                ...state,
                getProjectListResponse: { success: false, ...action.error },
                getProjectListResponseLoading: false
            };

        case actionType.GET_RECOMMENDATIONS_TEMPLATES_DROPDOWN_LIST_REQUEST:
            return {
                ...state,
                getTemplateDropdownListResponse: null,
                getTemplateDropdownListResponseLoading: true
            };
        case actionType.GET_RECOMMENDATIONS_TEMPLATES_DROPDOWN_LIST_SUCCESS:
            return {
                ...state,
                getTemplateDropdownListResponse: { success: true, ...action.response },
                getTemplateDropdownListResponseLoading: false
            };
        case actionType.GET_RECOMMENDATIONS_TEMPLATES_DROPDOWN_LIST_FAILURE:
            return {
                ...state,
                getTemplateDropdownListResponse: { success: false, ...action.error },
                getTemplateDropdownListResponseLoading: false
            };

        case actionType.UPDATE_SURVEY_RECOMMENDATION_TEMPLATE_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                [action?.isGlobal ? "templateEntityParams" : "projectEntityParams"]: { ...action.response }
            };
        case actionType.UPDATE_SURVEY_RECOMMENDATION_TEMPLATE_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };

        case actionType.RESET_TEMPLATE_REDUCER:
            return {
                ...state,
                getMobileRecommendationTemplatesResponse: { isLoading: false },
                getFcaProjectMobileRecomResponse: { isLoading: false }
            };

        case actionType.CLEAR_TEMPLATE_ENTITY_PARAMS:
            return {
                ...state,
                entityParams: {
                    entity: null,
                    selectedEntity: null,
                    selectedRowId: null,
                    paginationParams: {
                        totalPages: 0,
                        perPage: 100,
                        currentPage: 0,
                        totalCount: 0
                    },
                    params: {
                        limit: 100,
                        offset: 0,
                        search: "",
                        filters: null,
                        filterKeys: null,
                        list: null,
                        order: {}
                    },
                    wildCardFilterParams: {},
                    filterParams: {},
                    tableConfig: null
                }
            };
        case actionType.RESET_RECOMMENDATION_TEMPLATE:
            return {
                ...state,
                getMobileRecommendationTemplateByIdResponse: null,
                getFcaProjectMobileRecomByIdResponse: null
            };

        case actionType.ADD_FCA_PROJECT_RECOMMENDATION_DATA_REQUEST:
            return {
                ...state,
                addFCAProjectMobileRecomResponse: null,
                addFCAProjectMobileRecomResponseLoading: true
            };
        case actionType.ADD_FCA_PROJECT_RECOMMENDATION_DATA_SUCCESS:
            return {
                ...state,
                addFCAProjectMobileRecomResponse: { success: true, ...action.response },
                addFCAProjectMobileRecomResponseLoading: false
            };
        case actionType.ADD_FCA_PROJECT_RECOMMENDATION_DATA_FAILURE:
            return {
                ...state,
                addFCAProjectMobileRecomResponse: { success: false, ...action.error },
                addFCAProjectMobileRecomResponseLoading: false
            };

        case actionType.UPDATE_FCA_PROJECT_RECOMMENDATION_DATA_REQUEST:
            return {
                ...state,
                editFcaProjectMobileRecomResponse: null,
                editFCAProjectMobileRecomResponseLoading: true
            };
        case actionType.UPDATE_FCA_PROJECT_RECOMMENDATION_DATA_SUCCESS:
            return {
                ...state,
                editFcaProjectMobileRecomResponse: { success: true, ...action.response },
                editFCAProjectMobileRecomResponseLoading: false
            };
        case actionType.UPDATE_FCA_PROJECT_RECOMMENDATION_DATA_FAILURE:
            return {
                ...state,
                editFcaProjectMobileRecomResponse: { success: false, ...action.error },
                editFCAProjectMobileRecomResponseLoading: false
            };

        case actionType.DELETE_FCA_PROJECT_SURVEY_REQUEST:
            return {
                ...state,
                deleteFcaProjectMobileRecomResponse: null,
                deleteFcaProjectMobileRecomResponseLoading: true
            };
        case actionType.DELETE_FCA_PROJECT_SURVEY_SUCCESS:
            return {
                ...state,
                deleteFcaProjectMobileRecomResponse: { success: true, ...action.response },
                deleteFcaProjectMobileRecomResponseLoading: false
            };
        case actionType.DELETE_FCA_PROJECT_SURVEY_FAILURE:
            return {
                ...state,
                deleteFcaProjectMobileRecomResponse: { success: false, ...action.error },
                deleteFcaProjectMobileRecomResponseLoading: false
            };

        case actionType.GET_FCA_PROJECT_RECOMMENDATIONS_REQUEST:
            return {
                ...state,
                getFcaProjectMobileRecomResponse: { isLoading: true }
            };
        case actionType.GET_FCA_PROJECT_RECOMMENDATIONS_SUCCESS:
            return {
                ...state,
                getFcaProjectMobileRecomResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_FCA_PROJECT_RECOMMENDATIONS_FAILURE:
            return {
                ...state,
                getFcaProjectMobileRecomResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.GET_FCA_PROJECT_RECOMMENDATION_BY_ID_REQUEST:
            return {
                ...state,
                getFcaProjectMobileRecomByIdResponse: { isLoading: true }
            };
        case actionType.GET_FCA_PROJECT_RECOMMENDATION_BY_ID_SUCCESS:
            return {
                ...state,
                getFcaProjectMobileRecomByIdResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_FCA_PROJECT_RECOMMENDATION_BY_ID_FAILURE:
            return {
                ...state,
                getFcaProjectMobileRecomByIdResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.GET_SURVEY_RECOMMENDATION_TEMPLATE_EXPORT_REQUEST:
            return {
                ...state,
                getSurveyTemplateExportLoading: true
            };
        case actionType.GET_SURVEY_RECOMMENDATION_TEMPLATE_EXPORT_SUCCESS:
            return {
                ...state,
                getSurveyTemplateExportLoading: false
            };
        case actionType.GET_SURVEY_RECOMMENDATION_TEMPLATE_EXPORT_FAILURE:
            return {
                ...state,
                getSurveyTemplateExportLoading: false
            };

        case actionType.GET_COMMON_FILTER_LIST_FOR_FCA_SURVEY_PROJECT_REQUEST:
            return {
                ...state
            };
        case actionType.GET_COMMON_FILTER_LIST_FOR_FCA_SURVEY_PROJECT_SUCCESS:
            return {
                ...state,
                getListForCommonFilterResponse: { success: true, list: action.response || [] }
            };
        case actionType.GET_COMMON_FILTER_LIST_FOR_FCA_SURVEY_PROJECT_FAILURE:
            return {
                ...state,
                getListForCommonFilterResponse: { success: false, ...action.error }
            };
        case actionType.GROUP_FCA_SURVEY_UPDATE_REQUEST:
            return {
                ...state,
                getGroupUpdateRespose: { loading: true }
            };
        case actionType.GROUP_FCA_SURVEY_UPDATE_SUCCESS:
            return {
                ...state,
                getGroupUpdateRespose: { loading: false, ...action.response }
            };
        case actionType.GROUP_FCA_SURVEY_UPDATE_FAILURE:
            return {
                ...state,
                getGroupUpdateRespose: { loading: false, ...action.error }
            };

        case actionType.GET_FCA_SURVEY_PROJECT_FILTER_REQUEST:
            return {
                ...state,
                fcaSurveyProjectMasterFilterList: {
                    ...state.fcaSurveyProjectMasterFilterList,
                    [action.key]: { loading: true }
                }
            };
        case actionType.GET_FCA_SURVEY_PROJECT_FILTER_SUCCESS:
            return {
                ...state,
                fcaSurveyProjectMasterFilterList: {
                    ...state.fcaSurveyProjectMasterFilterList,
                    [action.key]: { list: [...action.response], loading: false }
                }
            };
        case actionType.GET_FCA_SURVEY_PROJECT_FILTER_FAILURE:
            return {
                ...state,
                fcaSurveyProjectMasterFilterList: {
                    ...state.fcaSurveyProjectMasterFilterList,
                    [action.key]: { loading: false }
                }
            };

        case actionType.RESET_GLOBAL_FCA_TABLE_DATA_SUCCESS:
            return {
                ...state,
                getMobileRecommendationTemplatesResponse: action.response,
                getFcaProjectMobileRecomResponse: action.response
            };
        case actionType.RESET_GLOBAL_FCA_TABLE_DATA_FAILURE:
            return {
                ...state,
                getMobileRecommendationTemplatesResponse: { success: false, ...action.error },
                getFcaProjectMobileRecomResponse: { success: false, ...action.error }
            };
        default:
            return state;
    }
};
